export const commons = {
  languages: {
    A1: 'A1 - Initial',
    A2: 'A2 - unter dem Durchschnitt',
    B1: 'B1 ist mittel',
    B2: 'B2 - Überdurchschnittlich',
    C1: 'C1 - Fortgeschritten',
    C2: 'C2 ist professionell',
    Native: 'Muttersprache'
  },
  roles: {
    club: 'Verein',
    artist: 'Künstler',
    admin: 'Administrator'
  },
  artistJobs: {
    Hostess: 'Hostess',
    GoGo: 'Gogo',
    Strip: 'Streifen'
  },
  schedule: {
    Monday: 'Montag',
    Tuesday: 'Dienstag',
    Wednesday: 'Mittwoch',
    Thursday: 'Donnerstag',
    Friday: 'Freitag',
    Saturday: 'Samstag',
    Sunday: 'Sonntag'
  },
  paymentFrequency: {
    Daily: 'Tag',
    Weekly: 'Woche',
    Monthly: 'Monat'
  },
  flightPaymentType: {
    Club: 'Auf Kosten des Clubs',
    Artist: 'Auf Kosten des Künstlers',
    Credit: 'Kreditvergabe',
    Agreement: 'Durch Vereinbarung',
    Compensation: 'Entschädigung'
  },
  artistConsumation: {
    label: 'Verbrauch',
    Active: 'Aktiv',
    Passive: 'Passiv'
  },
  workItemType: {
    Request: 'Anwendungen',
    Invite: 'Einladung'
  },
  workItemStatus: {
    Pending: 'Warten',
    Accepted: 'Akzeptiert',
    Rejected: 'Abgelehnt',
    Withdrawn: 'Aufdecken',
    Expired: 'Erleichtert',
    ContractOngoing: 'Der Vertrag ist gültig',
    ContractRequestedEndDate: 'Forderte das Datum des Vertrags an',
    FinishingContract: 'Der Vertrag endet',
    ContractCompleted: 'Der Vertrag ist abgeschlossen',
    ClubSetEndDate: 'Der Club setzte das Enddatum',
    Cancelled: 'Abgesagt'
  },
  artistStatuses: {
    LookingForWork: 'In der Suche',
    OnContract: 'Auf den Vertrag',
    FinishingContract: 'Ich beende den Vertrag ab',
    OnVacation: 'Auf Urlaub',
    HiddenFromSearch: 'Versteckt vor der Suche'
  },
  loading: {
    generic: 'Daten werden geladen ...',
    requests: 'Anwendungen sind geladen ...',
    invites: 'Einladungen sind geladen ...'
  },
  flightCompensationOptions: {
    oneMonth: 'Für einen Monat Vertragsmonat',
    twoMonths: 'Für 2 Monate Vertrag',
    threeMonths: 'Für 3 Monate Vertrag',
    sixMonths: 'Für 6 Monate des Vertrags kauft der Club eine Rückfahrkarte',
    backTicket: 'Rückfahrkarte'
  },
  transportFromAirport: {
    label: 'Transport vom Flughafen/Bahnhof',
    options: {
      clubOrganizes: 'Organisiert den Club',
      artistSelf: 'Die Künstlerin bekommt sich selbst'
    }
  },
  notFound: {
    generic: 'Die Registrierung ist leer.',
    requests: 'Es gibt noch keine Anwendungen.',
    invites: 'Es gibt noch keine Einladung.',
    artists: 'Derzeit ist die Liste der Künstler leer',
    search:
      'Wir haben den Club nicht auf Ihre Anfrage gefunden: (Bericht bitte darüber, dass wir die Suche besser machen können'
  },
  artistParametres: {
    weight: 'Gewicht',
    height: 'Höhe',
    body: 'Körper',
    chest: 'Brescent der Brust',
    waist: 'Der Taillenumfang',
    hips: 'Die Hüften der Hüften'
  },
  dressCodeOptions: {
    strip: 'Streifen',
    underwear: 'Unterwäsche',
    longDress: 'Langes Kleid',
    body: 'Körper',
    shortDress: 'Kurzes Kleid'
  },
  time: {
    years:
      '{count, plural, one {# Jahr} few {# Jahre} many {# Jahre} other {# Jahre}}',
    months:
      '{count, plural, one {# Monat} few {# Monate} many {# Monate} other {# Monate}}',
    days: '{count, plural, one {# Tag} few {# Tag} many {# Tage} other {# Tag}}'
  },
  contact_support: 'Brauchen Sie Hilfe? Kontaktieren Sie den Support',
  success_send_data: 'Die Daten werden erfolgreich gesendet',
  show_full: 'Komplett zeigen',
  worked_for: 'Bearbeitet (a)',
  club_reviews: 'Bewertungen über den Club',
  club_response: 'Clubantwort',
  response: 'Antwort',
  send: 'Schicken',
  cm: 'cm',
  kg: 'kg',
  no_rating_yet: 'Es gibt noch keine Bewertung',
  rating_allow: 'Künstler können den Club erst nach 21 Arbeitstagen bewerten',
  rating: 'Bewertung',
  rating_popup_header_1: 'Ihr Vertrag im Club',
  rating_popup_header_2: 'Vollendet',
  contractWeeks:
    '{count, plural, one {# Woche} few {# Wochen} many {# Wochen} other {# Wochen}}',
  rating_popup_text:
    'Für uns und andere Künstler ist es wichtig, Ihre Meinung zu diesem Ort zu kennen. Bitte bewerten Sie die Arbeit in diesem Club.',
  error_rating: 'Bewertungsfehler',
  no_rating:
    'Es gibt kein Element für die Bewertung dieses Clubs oder es wurde bereits bewertet',
  housing_quality: 'Wohnqualität',
  dressing_quality: 'Die Qualität der Umkleidekabine',
  management: 'Leitfaden und Personal',
  anonymous: 'Lassen Sie die Bewertung anonym',
  rate_work: 'Bewertung, Arbeit in diesem Club',
  submit: 'Schicken',
  years: 'Jahre',
  allow_note: 'Benachrichtigungen zulassen',
  allow_note_1:
    'Erlauben Sie mir die Benachrichtigungen für den richtigen Betrieb der Plattform, um wichtige Ereignisse nicht zu verpassen:',
  allow_note_2: 'Anwendungen und Einladungen',
  allow_note_3: 'Antworten von Clubs',
  allow_note_4: 'Nachrichten von Künstlern oder Managern',
  allow_note_5: 'Wir senden nur Arbeitsmeldungen - kein Spam.',
  'follow-us-in-social': 'Folgen Sie uns in sozialen Netzwerken:',
  continue: 'Weitermachen',
  'continue-with-google': 'Fahren Sie mit Google fort',
  artistHiringIsOpen: 'Eine Reihe von Künstlern ist offen',
  artistHiringIsClosed: 'Die Künstlergruppe ist geschlossen',
  acceptWithExperience: 'Wir akzeptieren ohne Erfahrung',
  dontAcceptWithoutExperience: 'Wir akzeptieren nicht ohne Erfahrung',
  info: 'Info',
  copyLink: 'Kopieren Sie den Link',
  withExperience: 'Mit Erfahrung',
  withouthExperience: 'Ohne Erfahrung',
  agree: 'Ich stimme den Bedingungen zu',
  change: 'Ändern',
  add: 'Hinzufügen',
  citizenship: 'Staatsbürgerschaft',
  selectCountry: 'Wählen Sie das Land',
  save: 'Speichern',
  'save-and-continue': 'Speichern und fahren Sie fort',
  edit: 'Bearbeiten',
  portfolio: 'Portfolio',
  close: 'Schließen',
  closed: 'Geschlossen',
  finish: 'Vollständig',
  help: 'Helfen',
  logout: 'Hinausgehen',
  country: 'Land',
  place: 'Standort',
  deleteAccount: 'Ein Konto löschen',
  changePassword: 'Kennwort ändern',
  hide: 'Verstecken',
  delete: 'Löschen',
  exit: 'Ja, ich möchte ausgehen',
  'undo-to-account': 'Zurück zum Konto',
  location: 'Standort',
  language: 'Sprachen',
  reviews: 'Bewertungen',
  parametres: 'Parameter',
  about: 'Über dich',
  my: 'Mein',
  photo: 'Foto',
  video: 'Video',
  experience: 'Erfahrung',
  galery: 'Galerie',
  write: 'Schreiben',
  yes: 'Ja',
  step: 'Schritt',
  no: 'NEIN',
  or: 'Oder',
  resend: 'Schicken',
  open: 'offen',
  cancel: 'Stornieren',
  need: 'Brauchen',
  dontNeed: 'Nicht benötigt',
  endWork: 'Ende der Arbeit',
  startDate: 'Das Startdatum der Arbeit',
  endDate: 'Das Ende des Endes der Arbeit',
  vacancy: 'Leerstand',
  creditation: 'Ticketkredite',
  aroundTheClock: 'Rund um die Uhr',
  flightTickets: 'Flüge',
  ticketCreditation: 'Ticketkredite',
  crazyMenu: 'Verrücktes Menü',
  tea: 'Tee',
  show: 'Zeigen',
  deposit: 'Kaution',
  guarantee: 'Garantie',
  rate: 'Gebot',
  clubFee: 'Clubgebühr',
  separated: 'Separate',
  forShift: 'Für Schichten',
  required: 'Unbedingt',
  optional: 'Nicht unbedingt',
  quantity: 'Menge',
  withouthExprience: 'Ohne Erfahrung',
  choreographerInClub: 'Die Anwesenheit eines Choreografen im Club',
  photoshootParticipation: 'Teilnahme an Fotoshootings',
  artistsInShift: 'Künstler in der Verschiebung',
  scenes: 'Szenen',
  dynamicPole: 'Pilon -Dynamik',
  staticPole: 'Pilon -Statik',
  artistTraining: 'Ausbildung von Künstlern',
  teching: 'Ausbildung',
  dressCodeForArtists: 'Kleiderordnung für Künstler',
  dressCode: 'Kleiderordnung',
  rentPayment: 'Zahlung von Wohnraum',
  utilitiesPayment: 'Zahlung der Gemeinschaft',
  clubProvidedAccommodation:
    'Die Unterkunft des Künstlers im Wohnungsbau aus dem Club',
  housingPhoto: 'Foto des Wohnraums',
  noteEditLater: 'Sie können später Änderungen vornehmen',
  paydByArtist: 'Künstler',
  paydByClub: 'Verein',
  peopleInRoom: 'Mann im Raum zu',
  uploadFromDevice: 'Herunterladen vom Gerät',
  uploadManyFromDevice: 'Laden Sie mehrere Fotos vom Gerät hoch',
  selectMainPhoto: 'Wählen Sie das Hauptfoto',
  photoParams: 'Die Größe des Fotos sollte __var_0__ MB nicht überschreiten',
  videoParams:
    'Die Größe des Videos sollte __var_0__ MB nicht überschreiten, unterstützte Formate: MP4, QuickTime,',
  general: 'Allgemein',
  payments: 'Zahlungen',
  full: 'Voll',
  topless: 'Topes',
  gogo: 'Go-Moh',
  crazymenu: 'Verrücktes Menü',
  continueFilling: 'Füllen Sie weiter',
  exitShort: 'Beenden',
  search: 'Suche',
  other: 'Andere',
  foreignLanguages: 'Fremdsprachen',
  dancer: 'Tänzer',
  untilNow: 'Miteinander ausgehen',
  invite: 'Einladen',
  cancelInvite: 'Die Einladung abbrechen',
  dateFormatPlaceholder: 'Dd.mm.yy',
  askArtist: 'Stellen Sie dem Künstler eine Frage',
  askClub: 'Stellen Sie dem Club eine Frage',
  reject: 'Ablehnen',
  accept: 'Akzeptieren',
  confirm: 'Bestätigen',
  iConfirm: 'Bestätigen',
  workAt: 'Funktioniert mit',
  setLastDate: 'Legen Sie das letzte Datum fest',
  lastWorkDay: 'Der letzte Arbeitstag',
  cancelArrangement: 'Die Vereinbarung kündigen',
  back: 'Zurück',
  wantedVacancy: 'Gewünschte freie Stellen',
  addClub: 'Fügen Sie den Club hinzu',
  goToInvitation: 'Gehen Sie zur Einladung',
  goToRequest: 'Zu der Anfrage gehen',
  vacancyConsider: 'Welche freien Stellen betrachten Sie?',
  super: 'Super',
  clubLocation: 'Der Ort des Clubs',
  specify: 'Angeben',
  housing: 'Gehäuse',
  position: 'Position',
  guest: 'Gast',
  workingHours: 'Öffnungszeiten',
  isPaydByClub: 'Vom Club bezahlt',
  isntPaydByClub: 'Vom Club nicht bezahlt',
  utilityPayments: 'Zahlung von Versorgungsunternehmen',
  payment: 'Zahlung',
  request: 'Anfrage',
  penalties: 'Geldstrafen',
  aboutClub: 'Über den Club',
  sendRequest: 'Anwenden',
  cancelRequest: 'Die Anwendung abbrechen',
  profile: 'Profil',
  chat: 'Chat',
  housigInClubApartsRequired:
    'Unterkünfte im Wohnungsbau aus dem Club sind erforderlich'
};
